import gql from "graphql-tag";

export default gql`
  query getCurrentPurchaseExposure($query: QueryInput, $offset: OffsetInput) {
    getCurrentPurchaseExposure(query: $query, offset: $offset) {
      purchase_id
      property_id
      property_name
      lease_id
      oak_entity_code
      oak_tranche_code
      date: purchase_date
      currency
      native_price
      native_noi
      price_usd
      noi_usd
      fx_rate
      fx_date
      fx_missing
      tenant_parsekey
      guarantor_parsekey
      security_parsekey
      is_vacant
      lease_end_date
      lease_date_needs_review
      property_type
      property_geo_code
      buildings
      square_feet
      master_lease
    }
  }
`;
